import { cn } from '@/lib/utils';

export function ScoreBadge({ score }: { score: number }) {
  return (
    <span className={cn(
      'inline-flex items-baseline gap-0.5 rounded-md px-1.5 py-0.5 text-xs font-semibold tabular-nums',
      score >= 70 ? 'bg-green-100 text-green-800' :
      score >= 40 ? 'bg-yellow-100 text-yellow-800' :
      score > 0 ? 'bg-gray-100 text-gray-800' :
      'bg-red-100 text-red-800',
    )}>
      {score}<span className="text-[10px] font-normal opacity-60">/100</span>
    </span>
  );
}
